import { FC, useMemo } from "react";
import { debounce } from "lodash-es";

import { getTranslations } from "../utils";
import { SearchArrowSVG } from "./SearchArrowSVG";

interface Props {
  initialTerm?: string | null;
  onInputChange?: (term: string) => void;
}

export const SearchInput: FC<Props> = ({ initialTerm, onInputChange }) => {
  const debouncedOnChange = useMemo(
    () =>
      debounce(
        (data) => onInputChange && onInputChange(data.target.value),
        500
      ),
    [onInputChange]
  );

  const searchLabel = useMemo(() => getTranslations("searchLabel"), []);
  const placeholderText = useMemo(
    () => getTranslations("searchInputPlaceholder"),
    []
  );

  return (
    <form className="search-field" onSubmit={(event) => event.preventDefault()}>
      <fieldset className="search-field__fieldset">
        <label className="search-field__label" htmlFor="search">
          <span className="visually-hidden">{searchLabel}</span>
          <button className="search-field__search" type="button" tabIndex={-1}>
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.75 21.2a9.6 9.6 0 100-19.2 9.6 9.6 0 000 19.2zM26.15 26l-6.96-6.96"
                stroke="currentColor"
                strokeWidth="4"
              ></path>
            </svg>
          </button>
          <input
            className="search-field__input has-border"
            id="search"
            name="search"
            type="search"
            placeholder={placeholderText}
            autoComplete="off"
            defaultValue={initialTerm || undefined}
            onChange={debouncedOnChange}
          />
          <div className="search-field__submit">
            <button type="submit" className="btn btn--red">
              <span className="btn__text">{searchLabel}</span>
              <span className="btn__icon">
                <SearchArrowSVG />
              </span>
            </button>
          </div>
        </label>
      </fieldset>
    </form>
  );
};
